export default "__VITE_ASSET__CA9$5Z01__"